import { render, staticRenderFns } from "./MbFilm.vue?vue&type=template&id=2b13ada7&"
import script from "./MbFilm.vue?vue&type=script&lang=js&"
export * from "./MbFilm.vue?vue&type=script&lang=js&"
import style0 from "./MbFilm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports